// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "1ffd01b4a402e87ad9e1a24f04fea09a51537ff2/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"2a9a7941","581":"e1bbb2aa","688":"2b6b0509","774":"c5660826"}[chunkId] + ".chunk.js";
};